import { useMessagedAsyncFn } from "@payping/web-components";
import { generateExcel } from "@/utils/excelGenerator";
import { useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";

export const useDownloadList = () => {
  const { createdRequest } = useAppSelector((state) => state.cashOuts);
  const { t } = useAppTranslation();
  const [, downloadList] = useMessagedAsyncFn(async () => {
    const result = createdRequest?.settlements;
    if (result) {
      const excelData = result.map(
        (data: {
          wage?: any;
          amount?: any;
          persianBankName?: any;
          clientRefId?: any;
          iban?: any;
          fullName?: any;
          description?: any;
        }) => {
          const { wage, amount, persianBankName, clientRefId, iban, fullName, description } = data;
          return [wage, amount, persianBankName, clientRefId, iban, fullName, description];
        }
      );
      generateExcel([
        [
          t("settlement.wage"),
          t("settlement.amount"),
          t("settlement.destinationBank"),
          t("settlement.clientRefId"),
          t("shaba"),
          t("fullName"),
          t("description"),
        ],
        [...excelData],
      ]);
    }
  }, [createdRequest?.settlements]);

  return { downloadList };
};
